import { Controller } from "@hotwired/stimulus"

// "Add from catalog": the search field submits its form into the results
// frame 200 ms after the last keystroke, from two characters (the legacy
// LineupSearch's debounce and minimum). Below that the results are
// cleared rather than searched for. "Searching…" shows until the frame
// comes back.
const DEBOUNCE_MS = 200
const MIN_LENGTH = 2

export default class extends Controller {
  static targets = ["form", "input", "status"]

  connect() {
    this.frame = this.element.querySelector("turbo-frame")
    this.onLoad = () => { this.statusTarget.hidden = true }
    this.frame?.addEventListener("turbo:frame-load", this.onLoad)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.frame?.removeEventListener("turbo:frame-load", this.onLoad)
  }

  changed() {
    clearTimeout(this.timer)
    const query = this.inputTarget.value.trim()
    if (query.length < MIN_LENGTH) {
      this.statusTarget.hidden = true
      this.frame?.replaceChildren()
      return
    }
    this.statusTarget.hidden = false
    this.timer = setTimeout(() => this.formTarget.requestSubmit(), DEBOUNCE_MS)
  }
}
